import { graphql } from "msw";
import { mockCart } from "./mockCart";
import {
  mockOnePassSubscription,
  mockOnePassSelectedOption,
} from "./mockOnePassSubscription";
import { ParcelsQuery } from "@cart-app/generated/graphql";

export const handler = graphql.query<ParcelsQuery>(
  "Parcels",
  (_request, response, context) =>
    response(
      context.data({
        __typename: "Query" as const,
        cart: {
          ...mockCart,
          clubSubscription: {
            ...mockOnePassSubscription,
            selectedOption: mockOnePassSelectedOption,
          },
        },
      })
    )
);
